/* eslint-disable @typescript-eslint/no-duplicate-enum-values */

/**
 * Kódy ikon odvozené přímo od LESS proměnných.
 * Změny je nutné reflektovat v proměnné @icon-codes.
 * @includeToDoc
 */
export enum IconCode {

    // Aliasy kódu ikon
    copy = "doc-copy",
    delete = "editorial-trash",
    detailFormActionIcon = "doc-wboard-line",
    download = "ui-cloud-download",
    edit = "editorial-pencil",
    execute = "music-play",
    export = "ui-export",
    false = "ui-cross-small",
    favorite = "ui-star",
    filter = "ui-filter",
    filterFilled = "ui-filter-filled",
    graph = "doc-pie",
    info = "ui-circle-info",
    layoutChange = "ui-layout-sidebar-l-half",
    moveLeft = "ui-circle-minus",
    moveRight = "ui-circle-plus",
    multi = "web-tabs-plus",
    new = "ui-plus",
    next = "ui-chevron-right",
    nextRecord = "ui-chevron-right",
    openDetail = "openDetail",
    openOnMainForm = "web-tabs-plus",
    prevRecord = "ui-chevron-left",
    print = "doc-printer",
    recordActions = "ui-more",
    refresh = "ui-refresh",
    remove = "editorial-trash",
    save = "tool-floppy-disk",
    selectAll = "web-tabs-check",
    selectFromLov = "ui-check",
    selectNone = "web-tabs-cross",
    settings = "settings-gear",
    true = "ui-check-small",
    triangleBottom = "ui-triangle-bottom",
    upload = "ui-cloud-upload",

    // Kódy ikon odvozené přímo z LESS proměnných
    // Regular verze (linky)
    buildingBed = "building-bed",
    buildingCabinet = "building-cabinet",
    buildingDaylight = "building-daylight",
    buildingDesk = "building-desk",
    buildingDoor = "building-door",
    buildingDrawer = "building-drawer",
    buildingExit = "building-exit",
    buildingFaucet = "building-faucet",
    buildingFireplace = "building-fireplace",
    buildingHangingRack = "building-hanging-rack",
    buildingHeater = "building-heater",
    buildingHouse = "building-house",
    buildingChair = "building-chair",
    buildingLamp = "building-lamp",
    buildingLampA = "building-lamp-a",
    buildingLift = "building-lift",
    buildingMuseum = "building-museum",
    buildingOffice = "building-office",
    buildingOfficeA = "building-office-a",
    buildingOfficeAddB = "building-office-add-b",
    buildingOfficeSettingsB = "building-office-settings-b",
    buildingPlanBalcony = "building-plan-balcony",
    buildingRealEstateDimensionsBlock = "building-real-estate-dimensions-block",
    buildingRealEstateDimensionsPlan = "building-real-estate-dimensions-plan",
    buildingRockerSwitch = "building-rocker-switch",
    buildingSafetyFireShield = "building-safety-fire-shield",
    buildingSofa = "building-sofa",
    buildingSofaA = "building-sofa-a",
    buildingToilet = "building-cabinet",
    buildingView = "building-view",
    comAdvertisingMegaphone = "com-advertising-megaphone",
    comBell = "com-bell",
    comBubble = "com-bubble",
    comBubbleA = "com-bubble-a",
    comBubbleDot = "com-bubble-dot",
    comBubbleDotA = "com-bubble-dot-a",
    comBubbleGroup = "com-bubble-group",
    comBubbleGroupA = "com-bubble-group-a",
    comBubbleLine = "com-bubble-line",
    comBubbleLineA = "com-bubble-line-a",
    comHelp = "com-help",
    comHelpA = "com-help-a",
    comLanguage = "com-language",
    comMail = "com-mail",
    comMailClock = "com-mail-clock",
    comMailCross = "com-mail-cross",
    comMailDownload = "com-mail-download",
    comMailCheck = "com-mail-check",
    comMailMinus = "com-mail-minus",
    comMailOpen = "com-mail-open",
    comMailOpenWarning = "com-mail-open-warning",
    comMailPlus = "com-mail-plus",
    comMailReceive = "com-mail-receive",
    comMailSync = "com-mail-sync",
    comMailWarning = "com-mail-warning",
    comMegaphone = "com-megaphone",
    comMic = "com-mic",
    comMicMute = "com-mic-mute",
    comMicrophonePodcast = "com-microphone-podcast-2",
    comPaperplane = "com-paperplane",
    comPhone = "com-phone",
    comPhoneLandline = "com-phone-landline",
    comPictures = "com-pictures",
    comPostcard = "com-postcard",
    comSatellite = "com-satellite",
    comVoicemail = "com-voicemail",
    comWarning = "com-warning",
    docAnalyticsUp = "doc-analytics-up",
    docArchive = "doc-archive",
    docArchiveDownload = "doc-archive-download",
    docArchiveEmpty = "doc-archive-empty",
    docArchiveFolder = "doc-archive-folder",
    docArchiveUpload = "doc-archive-upload",
    docArticle = "doc-article",
    docAttachment = "doc-attachment",
    docBook = "doc-book",
    docBookA = "doc-book-a",
    docBookB = "doc-book-b",
    docBookCash = "doc-book-cash",
    docBookDownload = "doc-book-download",
    docBookLibrary = "doc-book-library",
    docBookmark = "doc-bookmark",
    docBookModules = "doc-book-modules",
    docBookSettings = "doc-book-settings",
    docBookTarget = "doc-book-target",
    docBookUpload = "doc-book-upload",
    docBoxP = "doc-box-p",
    docBriefcase = "doc-briefcase",
    docCamera = "doc-camera",
    docCommonFileEdit = "doc-common-file-edit",
    docCommonFileHome = "doc-common-file-home",
    docCommonFileTextEdit = "doc-common-file-text-edit",
    docCompose = "doc-compose",
    docCopy = "doc-copy",
    docDiary = "doc-diary",
    docDownload = "doc-download",
    docFileBlank = "doc-file-blank",
    docFileBookmark = "doc-file-bookmark",
    docFileCross = "doc-file-cross",
    docFileCheck = "doc-file-check",
    docFileLine = "doc-file-line",
    docFileMinus = "doc-file-minus",
    docFileNext = "doc-file-next",
    docFilePlus = "doc-file-plus",
    docFilePrev = "doc-file-prev",
    docFilePrint = "doc-file-print",
    docFileRefresh = "doc-file-refresh",
    docFileSave = "doc-file-save",
    docFileXls = "doc-file-xls",
    docFolder = "doc-folder",
    docFolderCross = "doc-folder-cross",
    docFolderHome = "doc-folder-home",
    docFolderCheck = "doc-folder-check",
    docFolderMinus = "doc-folder-minus",
    docFolderPlus = "doc-folder-plus",
    docFolderSync = "doc-folder-sync",
    docGlasses = "doc-glasses",
    docIdCardVertical = "doc-id-card-vertical",
    docImage = "doc-image",
    docImageA = "doc-image-a",
    docInvoice = "doc-invoice",
    docList = "doc-list",
    docListNumbers = "doc-list-numbers",
    docMailboxIn = "doc-mailbox-in",
    docMinus = "doc-minus",
    docNewspaper = "doc-newspaper",
    docNotesFlip = "doc-notes-flip",
    docNotesGive = "doc-notes-give",
    docNotesHome = "doc-notes-home",
    docNotesPaperText = "doc-notes-paper-text",
    docNotesUpload = "doc-notes-upload",
    docOfficeFilePdf = "doc-office-file-pdf",
    docOfficeFolder = "doc-office-folder",
    docOfficeStampDocument = "doc-office-stamp-document",
    docPaperLine = "doc-paper-line",
    docPapers = "doc-papers",
    docPaperStack = "doc-paper-stack",
    docPie = "doc-pie",
    docPin = "doc-pin",
    docPlus = "doc-plus",
    docPrinter = "doc-printer",
    docProfile = "doc-profile",
    docStack = "doc-stack",
    docTaskChecklist = "doc-task-checklist",
    docTaskListQuestion = "doc-task-list-question",
    docTodoList = "doc-todo-list",
    docTodoListSquare = "doc-todo-list-square",
    docTodoListUser = "doc-todo-list-user",
    docUpload = "doc-upload",
    docWboardArrowTop = "doc-wboard-arrow-top",
    docWboardGear = "doc-wboard-gear",
    docWboardCheck = "doc-wboard-check",
    docWboardLine = "doc-wboard-line",
    docWboardSearch = "doc-wboard-search",
    editorialAlignCenter = "editorial-align-center",
    editorialAlignLeft = "editorial-align-left",
    editorialAlignRight = "editorial-align-right",
    editorialBookmark = "editorial-bookmar",
    editorialBrush = "editorial-brush",
    editorialColorPalette = "editorial-color-palette",
    editorialCombineIntersect = "editorial-combine-intersect",
    editorialFontSize = "editorial-font-size",
    editorialHash = "editorial-hash",
    editorialIndentLeft = "editorial-indent-left",
    editorialIndentRight = "editorial-indent-right",
    editorialItalicOff = "editorial-italic-off",
    editorialParagraph = "editorial-paragraph",
    editorialParagraphFirstLetter = "editorial-paragraph-first-letter",
    editorialPen = "editorial-pen",
    editorialPencil = "editorial-pencil",
    editorialPencilSmall = "editorial-pencil-small",
    editorialRedo = "editorial-redo",
    editorialSortAsc = "editorial-sort-asc",
    editorialSortCancel = "editorial-sort-cancel",
    editorialSortDesc = "editorial-sort-desc",
    editorialTextBold = "editorial-text-bold",
    editorialTextFormat = "editorial-text-format",
    editorialTextItalic = "editorial-text-italic",
    editorialTextStrike = "editorial-text-strike-through",
    editorialTextStyle = "editorial-text-style",
    editorialTextUnderline = "editorial-text-underline",
    editorialTrash = "editorial-trash",
    editorialTypingMachine = "editorial-typing-machine",
    editorialUndo = "editorial-undo",
    envAtomicBomb = "env-atomic-bomb",
    envEarth = "env-earth",
    envFlower = "env-flower",
    envLeaf = "env-leaf",
    envMountains = "env-mountains",
    envTree = "env-tree",
    envTreeA = "env-tree-a",
    locationCompass = "location-compass",
    locationDirection = "location-direction",
    locationDirectionSign = "location-direction-sign",
    locationMap = "location-map",
    locationMapCross = "location-map-cross",
    locationPin = "location-pin",
    locationPinA = "location-pin-a",
    locationPinB = "location-pin-b",
    locationPinCheck = "location-pin-check",
    locationPinMap = "location-pin-map",
    locationPinMinus = "location-pin-minus",
    locationPinPlus = "location-pin-plus",
    locationPins = "location-pins",
    locationStreetSign = "location-street-sign",
    locationStreetSignA = "location-street-sign-a",
    logoApple = "logo-apple",
    logoLinux = "logo-linux",
    logoWindows = "logo-windows",
    miscBulletDiamond = "misc-bullet-diamond",
    miscCrown = "misc-crown",
    miscCube = "misc-cube",
    miscCursorHandOpen = "misc-cursor-hand-open",
    miscFemaleSign = "misc-female-sign",
    miscGesture = "misc-gesture",
    miscGestureDoubleTap = "misc-gesture-double-tap",
    miscGestureSwipeLeft = "misc-gesture-swipe-left",
    miscGestureSwipeRight = "misc-gesture-swipe-right",
    miscGestureTap = "misc-gesture-tap",
    miscGlobe = "misc-globe",
    miscGridPerspective = "misc-grid-perspective",
    miscMaleSign = "misc-male-sign",
    miscPuzzle = "misc-puzzle",
    miscReceptionHotelBell = "misc-reception-hotel-bell",
    miscSmileAngry = "misc-smile-angry",
    miscSmileHappy = "misc-smile-happy",
    miscSmileLaught = "misc-smile-laught",
    miscSmileMeh = "misc-smile-meh",
    miscSmileSad = "misc-smile-sad",
    miscWifi = "misc-wifi",
    musicAlbum = "music-album",
    musicCd = "music-cd",
    musicEject = "music-eject",
    musicEqualiser = "music-equaliser",
    musicList = "music-list",
    musicMic = "music-mic",
    musicNext = "music-next",
    musicNextA = "music-next-a",
    musicNote = "music-note",
    musicNoteA = "music-note-a",
    musicPause = "music-pause",
    musicPlay = "music-play",
    musicPlaylist = "music-playlist",
    musicPrevious = "music-previous",
    musicPreviousA = "music-previous-a",
    musicRadio = "music-radio",
    musicRepeat = "music-repeat",
    musicRepeatOne = "music-repeat-one",
    musicShuffle = "music-shuffle",
    musicSpeaker = "music-speaker",
    musicStop = "music-stop",
    musicVolumeHigh = "music-volume-high",
    musicVolumeLow = "music-volume-low",
    musicVolumeMedium = "music-volume-medium",
    musicVolumeMute = "music-volume-mute",
    musicHeadphones = "music-headphones",
    musicHeadphonesA = "music-headphones-a",
    settingsAirplane = "settings-airplane",
    settingsAutoFlash = "settings-auto-flash",
    settingsColorMode = "settings-color-mode",
    settingsComonent = "settings-comonent",
    settingsEqualizer = "settings-equalizer",
    settingsGear = "settings-gear",
    settingsGearA = "settings-gear-a",
    settingsHotspot = "settings-hotspot",
    settingsMachineTrack = "settings-machine-track",
    settingsWrench = "settings-wrench",
    shopAccountingBillStack = "shop-accounting-bill-stack",
    shopBag = "shop-bag",
    shopBarcode = "shop-barcode",
    shopBasket = "shop-basket",
    shopBill = "shop-bill",
    shopBox = "shop-box",
    shopBoxEmpty = "shop-box-empty",
    shopBoxMinus = "shop-box-minus",
    shopBoxPlus = "shop-box-plus",
    shopCartDownload = "shop-cart-download",
    shopCartEmpty = "shop-cart-empty",
    shopCartFull = "shop-cart-full",
    shopCash = "shop-cash",
    shopCashDolar = "shop-cash-dolar",
    shopCoins = "shop-coins",
    shopCreditcard = "shop-creditcard",
    shopDiamond = "shop-diamond",
    shopDiscountCircle = "shop-discount-circle",
    shopDiscountCoupon = "shop-discount-coupon",
    shopDolar = "shop-dolar",
    shopEuro = "shop-euro",
    shopMarket = "shop-market",
    shopMastercard = "shop-mastercard",
    shopPerformanceMoneyDecrease = "shop-performance-money-decrease",
    shopPound = "shop-pound",
    shopPresent = "shop-present",
    shopSafeBox = "shop-safe-box",
    shopSavingPiggyBank = "shop-saving-piggy-bank",
    shopShipmentPackages = "shop-shipment-packages",
    shopSuitcase = "shop-suitcase",
    shopTag = "shop-tag",
    shopTagCross = "shop-tag-cross",
    shopTagDatabase = "shop-tag-database",
    shopTagCheck = "shop-tag-check",
    shopTagInfo = "shop-tag-info",
    shopTagLock = "shop-tag-lock",
    shopTagMinus = "shop-tag-minus",
    shopTagPlus = "shop-tag-plus",
    shopTagRefresh = "shop-tag-refresh",
    shopTagSearch = "shop-tag-search",
    shopTie = "shop-tie",
    shopTracking = "shop-tracking",
    shopWallet = "shop-wallet",
    sportBadge = "sport-badge",
    sportBadgeB = "sport-badge-b",
    sportBadgeC = "sport-badge-c",
    sportBadgeH = "sport-badge-h",
    sportDumbell = "sport-dumbell",
    sportFlag = "sport-flag",
    sportGauge = "sport-gauge",
    sportHeartPulse = "sport-heart-pulse",
    sportMedic = "sport-medic",
    sportMedicineLab = "sport-medicine-lab",
    sportPuzzle = "sport-puzzle",
    sportTrophy = "sport-trophy",
    sportTv = "sport-tv",
    timeAlarm = "time-alarm",
    timeCalendar = "time-calendar",
    timeCalendarCash = "time-calendar-cash",
    timeCalendarClock = "time-calendar-clock",
    timeCalendarDots = "time-calendar-dots",
    timeCalendarSmall = "time-calendar-small",
    timeCalendarWeek = "time-calendar-week",
    timeClockCircle = "time-clock-circle",
    timeClockF = "time-clock-f",
    timeHourglass = "time-hourglass",
    timeSpeedMeter = "time-speed-meter",
    timeStopwatch = "time-stopwatch",
    timeTimer = "time-timer",
    timeWatch = "time-watch",
    toolAndroidType = "tool-android-type",
    toolAreaType = "tool-area-type",
    toolBinoculars = "tool-binoculars",
    toolCalc = "tool-calc",
    toolCamera = "tool-camera",
    toolCompass = "tool-compass",
    toolConsole = "tool-console",
    toolConsoleA = "tool-console-a",
    toolDisplay = "tool-display",
    toolDisplayUser = "tool-display-user",
    toolFireExtinguisher = "tool-fire-extinguisher",
    toolFlashlight = "tool-flashlight",
    toolFloppyDisk = "tool-floppy-disk",
    toolFloppyDisks = "tool-floppy-disks",
    toolFloppyEdit = "tool-floppy-edit",
    toolFocus = "tool-focus",
    toolGearsType = "tool-gears-type",
    toolGrid = "tool-grid",
    toolHammer = "tool-hammer",
    toolHammerA = "tool-hammer-a",
    toolHammerAngle = "tool-hammer-angle",
    toolHammerPlus = "tool-hammer-plus",
    toolHardwareType = "tool-hardware-type",
    toolIntType = "tool-int-type",
    toolLaptop = "tool-laptop",
    toolMagicWand = "tool-magic-wand",
    toolMagnet = "tool-magnet",
    toolModuleThree = "tool-module-three",
    toolMouse = "tool-mouse",
    toolPhone = "tool-phone",
    toolPhoneLandscape = "tool-phone-landscape",
    toolPlug = "tool-plug",
    toolProjector = "tool-projector",
    toolPropertyType = "tool-property-type",
    toolProtectionType = "tool-protection-type",
    toolRazor = "tool-razor",
    toolRouterSignal = "tool-router-signal",
    toolRuler = "tool-ruler",
    toolRulerB = "tool-ruler-b",
    toolRulerCorner = "tool-ruler-corner",
    toolSateliteType = "tool-satelite-type",
    toolsBox = "tools-box",
    toolScissors = "tool-scissors",
    toolSmartphonePay = "tool-smartphone-pay",
    toolTextType = "tool-text-type",
    toolUmbrella = "tool-umbrella",
    transportBicycle = "transport-bicycle",
    transportBus = "transport-bus",
    transportBusA = "transport-bus-a",
    transportBusTicket = "transport-bus-ticket",
    transportCar = "transport-car",
    transportCarA = "transport-car-a",
    transportShip = "transport-ship",
    transportShipA = "transport-ship-a",
    transportSignStop = "transport-sign-stop",
    transportTrain = "transport-train",
    transportTruck = "transport-truck",
    transportTruckA = "transport-truck-a",
    uiAddConnectionPoint = "ui-add-connection-point",
    uiAlignBottom = "ui-align-bottom",
    uiAlignLeft = "ui-align-left",
    uiAlignRight = "ui-align-right",
    uiAlignTop = "ui-align-top",
    uiArrowBottom = "ui-arrow-bottom",
    uiArrowBottomA = "ui-arrow-bottom-a",
    uiArrowBottomLeft = "ui-arrow-bottom-left",
    uiArrowBottomRight = "ui-arrow-bottom-right",
    uiArrowBottomSmall = "ui-arrow-bottom-small",
    uiArrowLeft = "ui-arrow-left",
    uiArrowLeftA = "ui-arrow-left-a",
    uiArrowLeftSmall = "ui-arrow-left-small",
    uiArrowRight = "ui-arrow-right",
    uiArrowRightA = "ui-arrow-right-a",
    uiArrowRightSmall = "ui-arrow-right-small",
    uiArrowTop = "ui-arrow-top",
    uiArrowTopA = "ui-arrow-top-a",
    uiArrowTopLeft = "ui-arrow-top-left",
    uiArrowTopRight = "ui-arrow-top-right",
    uiArrowTopSmall = "ui-arrow-top-small",
    uiAttribute = "ui-attribute",
    uiAttributeInherited = "ui-attribute-inherited",
    uiBackspace = "ui-backspace",
    uiBlock = "ui-block",
    uiBoxHelp = "ui-box-help",
    uiBoxWarning = "ui-box-warning",
    uiBulletView = "ui-bullet-view",
    uiCard = "ui-card",
    uiCardView = "ui-card-view",
    uiCircle = "ui-circle",
    uiCircleArrowBottom = "ui-circle-arrow-bottom",
    uiCircleArrowLeft = "ui-circle-arrow-left",
    uiCircleArrowRight = "ui-circle-arrow-right",
    uiCircleArrowTop = "ui-circle-arrow-top",
    uiCircleCross = "ui-circle-cross",
    uiCircleHelp = "ui-circle-help",
    uiCircleCheck = "ui-circle-check",
    uiCircleCheckA = "ui-circle-check-a",
    uiCircleChevronBottom = "ui-circle-chevron-bottom",
    uiCircleChevronLeft = "ui-circle-chevron-left",
    uiCircleChevronRight = "ui-circle-chevron-right",
    uiCircleChevronTop = "ui-circle-chevron-top",
    uiCircleInfo = "ui-circle-info",
    uiCircleMinus = "ui-circle-minus",
    uiCirclePlus = "ui-circle-plus",
    uiCircleWarning = "ui-circle-warning",
    uiCloseParallelConnection = "ui-close-parallel-connection",
    uiCloudDownload = "ui-cloud-download",
    uiCloudUpload = "ui-cloud-upload",
    uiCmd = "ui-cmd",
    uiCombobox = "ui-combobox",
    uiCondition = "ui-condition",
    uiCone = "ui-cone",
    uiConnection = "ui-connection",
    uiConnectionInherited = "ui-connection-inherited",
    uiConnectionOpen = "ui-connection-open",
    uiConnectionOpenInherited = "ui-connection-open-inherited",
    uiCreateConnection = "ui-create-connection",
    uiCrop = "ui-crop",
    uiCross = "ui-cross",
    uiCrossSmall = "ui-cross-small",
    uiDot = "ui-dot",
    uiDotLarge = "ui-dot-large",
    uiDragHandle = "ui-drag-handle",
    uiEnlarge = "ui-enlarge",
    uiExpand = "ui-expand",
    uiExport = "ui-export",
    uiEye = "ui-eye",
    uiEyeCross = "ui-eye-cross",
    uiFilter = "ui-filter",
    uiForward = "ui-forward",
    uiFrame = "ui-frame",
    uiFullscreen = "ui-fullscreen",
    uiFullscreenA = "ui-fullscreen-a",
    uiGridView = "ui-grid-view",
    uiHamburger = "ui-hamburger",
    uiHeart = "ui-heart",
    uiHelp = "ui-help",
    uiHierarchy = "ui-hierarchy",
    uiHierarchyTree = "ui-hierarchy-tree",
    uiHome = "ui-home",
    uiHomeA = "ui-home-a",
    uiHouse = "ui-house",
    uiCheck = "ui-check",
    uiCheckbox = "ui-checkbox",
    uiCheckSmall = "ui-check-small",
    uiCheckSmallCircle = "ui-check-small-circle",
    uiChevronBottom = "ui-chevron-bottom",
    uiChevronBottomSmall = "ui-chevron-bottom-small",
    uiChevronLeft = "ui-chevron-left",
    uiChevronLeftSmall = "ui-chevron-left-small",
    uiChevronRight = "ui-chevron-right",
    uiChevronRightSmall = "ui-chevron-right-small",
    uiChevronRightTripple = "ui-chevron-right-tripple",
    uiChevronTop = "ui-chevron-top",
    uiChevronTopSmall = "ui-chevron-top-small",
    uiImport = "ui-import",
    uiInLink = "ui-in-link",
    uiKeyboard = "ui-keyboard",
    uiLayoutHalf = "ui-layout-half",
    uiLayoutHalfHorizontal = "ui-layout-half-horizontal",
    uiLayoutSidebarL = "ui-layout-sidebar-l",
    uiLayoutSidebarLHalf = "ui-layout-sidebar-l-half",
    uiLayoutTableView = "ui-layout-table-view",
    uiLayoutThirdVertical = "ui-layout-third-vertical",
    uiLayoutWireframe = "ui-layout-wireframe",
    uiListForward = "ui-list-forward",
    uiListShare = "ui-list-share",
    uiListUser = "ui-list-user",
    uiListView = "ui-list-view",
    uiLogin = "ui-login",
    uiLogout = "ui-logout",
    uiMethod = "ui-method",
    uiMethodInherited = "ui-method-inherited",
    uiMinus = "ui-minus",
    uiMinusSmall = "ui-minus-small",
    uiMore = "ui-more",
    uiMoreHorizontalSmall = "ui-more-horizontal-small",
    uiMoreSmall = "ui-more-small",
    uiMoreSmallCircle = "ui-more-small-circle",
    uiMoreVertical = "ui-more-vertical",
    uiMoreVerticalSmall = "ui-more-vertical-small",
    uiMove = "ui-move",
    uiNext = "ui-next",
    uiNextA = "ui-next-a",
    uiNumber = "ui-number",
    uiOutLink = "ui-out-link",
    uiPixel = "ui-pixel",
    uiPlus = "ui-plus",
    uiPlusSmall = "ui-plus-small",
    uiPopup = "ui-popup",
    uiPower = "ui-power",
    uiPrevious = "ui-previous",
    uiPreviousA = "ui-previous-a",
    uiPropertyAnd = "ui-property-and",
    uiRadiobutton = "ui-radiobutton",
    uiRefresh = "ui-refresh",
    uiRemoveConnectionPoint = "ui-remove-connection-point",
    uiRepeating = "ui-repeating",
    uiReply = "ui-reply",
    uiResizeBottomLeft = "ui-resize-bottom-left",
    uiResizeBottomRight = "ui-resize-bottom-right",
    uiResizeDiagonal = "ui-resize-diagonal",
    uiResizeHorizontal = "ui-resize-horizontal",
    uiResizeTopLeft = "ui-resize-top-left",
    uiResizeTopRight = "ui-resize-top-right",
    uiResizeVertical = "ui-resize-vertical",
    uiScrollHorizontal = "ui-scroll-horizontal",
    uiScrollVertical = "ui-scroll-vertical",
    uiSearch = "ui-search",
    uiSearchCross = "ui-search-cross",
    uiSearchCheck = "ui-search-check",
    uiSearchMinus = "ui-search-minus",
    uiSearchPlus = "ui-search-plus",
    uiShrink = "ui-shrink",
    uiSplitHorizontal = "ui-split-horizontal",
    uiSplitVertical = "ui-split-vertical",
    uiSqareDashed = "ui-sqare-dashed",
    uiStar = "ui-star",
    uiSync = "ui-sync",
    uiTarget = "ui-target",
    uiTreeLoad = "ui-tree-load",
    uiTreeSave = "ui-tree-save",
    uiTriangleBottom = "ui-triangle-bottom",
    uiTriangleLeft = "ui-triangle-left",
    uiTriangleRight = "ui-triangle-right",
    uiTriangleTop = "ui-triangle-top",
    uiUndo = "ui-undo",
    uiUndoA = "ui-undo-a",
    uiUndoB = "ui-undo-b",
    uiWindow = "ui-window",
    uiZoomInPage = "ui-zoom-in-page",
    user = "user",
    userBusinessDealCashExchange = "user-business-deal-cash-exchange",
    userCircle = "user-circle",
    userContactBook = "user-contact-book",
    userContactBookA = "user-contact-book-a",
    userCross = "user-cross",
    userFemale = "user-female",
    userFemaleCross = "user-female-cross",
    userFemaleCheck = "user-female-check",
    userFemaleList = "user-female-list",
    userFemaleMinus = "user-female-minus",
    userFemalePlus = "user-female-plus",
    userFemaleSign = "user-female-sign",
    userForward = "user-forward",
    userGear = "user-gear",
    userGroup = "user-group",
    userGroupA = "user-group-a",
    userGroupFemale = "user-group-female",
    userHeadset = "user-headset",
    userCheck = "user-check",
    userCheckA = "user-check-a",
    userCheckB = "user-check-b",
    userKey = "user-key",
    userList = "user-list",
    userLock = "user-lock",
    userLockUnlocked = "user-lock-unlocked",
    userLockUnlockedB = "user-lock-unlocked-b",
    userMale = "user-male",
    userMaleCross = "user-male-cross",
    userMaleCheck = "user-male-check",
    userMaleList = "user-male-list",
    userMaleMinus = "user-male-minus",
    userMalePlus = "user-male-plus",
    userMaleSign = "user-male-sign",
    userMessagesPeopleUserWarning = "user-messages-people-user-warning",
    userMinus = "user-minus",
    userMultipleUsers = "user-multiple-users",
    userPlus = "user-plus",
    userShare = "user-share",
    userSingleNeutralActionsBlock = "user-single-neutral-actions-block",
    userSingleNeutralActionsEdit = "user-single-neutral-actions-edit",
    userSingleNeutralHome = "user-single-neutral-home",
    userToiletSign = "user-toilet-sign",
    userWalking = "user-walking",
    videoPlayer = "video-player",
    weatherCloud = "weather-cloud",
    weatherCloudFlash = "weather-cloud-flash",
    weatherCloudRain = "weather-cloud-rain",
    weatherCloudSnow = "weather-cloud-snow",
    weatherFire = "weather-fire",
    weatherFlash = "weather-flash",
    weatherMoon = "weather-moon",
    weatherMoonA = "weather-moon-a",
    weatherSnowflake = "weather-snowflake",
    weatherSun = "weather-sun",
    weatherSunCloudSnow = "weather-sun-cloud-snow",
    weatherSunrise = "weather-sunrise",
    weatherThermometer = " weather-thermometer",
    weatherWater = "weather-water",
    weatherWindsock = "weather-windsock",
    webAnalyticsNet = "web-analytics-net",
    webAtSign = "web-at-sign",
    webBarsHome = "web-bars-home",
    webBrokenLink = "web-broken-link",
    webBrowser = "web-browser",
    webBrowserGrid = "web-browser-grid",
    webBrowserWindow = "web-browser-window",
    webBug = "web-bug",
    webCode = "web-code",
    webCollapseDown = "web-collapse-down",
    webCollapseLeft = "web-collapse-left",
    webCollapseRight = "web-collapse-right",
    webCollapseUp = "web-collapse-up",
    webConsole = "web-console",
    webDataFileBars = "web-data-file-bars",
    webDataFileBarsHome = "web-data-file-bars-home",
    webFlag = "web-flag",
    webFlagC = "web-flag-c",
    webGlobe = "web-globe",
    webGridUpload = "web-grid-upload",
    webChart = "web-chart",
    webIncreaseMail = "web-increase-mail",
    webLink = "web-link",
    webLinkB = "web-link-b",
    webLinkBCheck = "web-link-b-check",
    webRss = "web-rss",
    webRssSettings = "web-rss-settings",
    webServer = "web-server",
    webShare = "web-share",
    webStatistic = "web-statistic",
    webTabletIncrease = "web-tablet-increase",
    webTabs = "web-tabs",
    webTabsCross = "web-tabs-cross",
    webTabsCheck = "web-tabs-check",
    webTabsMinus = "web-tabs-minus",
    webTabsPlus = "web-tabs-plus",
    webWarning = "web-warning",
    webWebcam = "web-webcam",

    // Bold verze (tučné nebo vyplněné)
    // Liší se koncovkami *Filled a *-filled

    buildingBedFilled = "building-bed-filled",
    buildingCabinetFilled = "building-cabinet-filled",
    buildingDaylightFilled = "building-daylight-filled",
    buildingDeskFilled = "building-desk-filled",
    buildingDoorFilled = "building-door-filled",
    buildingDrawerFilled = "building-drawer-filled",
    buildingExitFilled = "building-exit-filled",
    buildingFaucetFilled = "building-faucet-filled",
    buildingFireplaceFilled = "building-fireplace-filled",
    buildingHangingRackFilled = "building-hanging-rack-filled",
    buildingHeaterFilled = "building-heater-filled",
    buildingHouseFilled = "building-house-filled",
    buildingChairFilled = "building-chair-filled",
    buildingLampAFilled = "building-lamp-a-filled",
    buildingLampFilled = "building-lamp-filled",
    buildingLiftFilled = "building-lift-filled",
    buildingMuseumFilled = "building-museum-filled",
    buildingOfficeAddBFilled = "building-office-add-b-filled",
    buildingOfficeAFilled = "building-office-a-filled",
    buildingOfficeFilled = "building-office-filled",
    buildingOfficeSettingsBFilled = "building-office-settings-b-filled",
    buildingPlanBalconyFilled = "building-plan-balcony-filled",
    buildingRealEstateDimensionsBlockFilled = "building-real-estate-dimensions-block-filled",
    buildingRealEstateDimensionsPlanFilled = "building-real-estate-dimensions-plan-filled",
    buildingRockerSwitchFilled = "building-rocker-switch-filled",
    buildingSafetyFireShieldFilled = "building-safety-fire-shield-filled",
    buildingSofaAFilled = "building-sofa-a-filled",
    buildingSofaFilled = "building-sofa-filled",
    buildingToiletFilled = "building-cabinet-filled",
    buildingViewFilled = "building-view-filled",
    comAdvertisingMegaphoneFilled = "com-advertising-megaphone-filled",
    comBellFilled = "com-bell-filled",
    comBubbleAFilled = "com-bubble-a-filled",
    comBubbleDotAFilled = "com-bubble-dot-a-filled",
    comBubbleDotFilled = "com-bubble-dot-filled",
    comBubbleFilled = "com-bubble-filled",
    comBubbleGroupAFilled = "com-bubble-group-a-filled",
    comBubbleGroupFilled = "com-bubble-group-filled",
    comBubbleLineAFilled = "com-bubble-line-a-filled",
    comBubbleLineFilled = "com-bubble-line-filled",
    comHelpAFilled = "com-help-a-filled",
    comHelpFilled = "com-help-filled",
    comLanguageFilled = "com-language-filled",
    comMailClockFilled = "com-mail-clock-filled",
    comMailCrossFilled = "com-mail-cross-filled",
    comMailDownloadFilled = "com-mail-download-filled",
    comMailFilled = "com-mail-filled",
    comMailCheckFilled = "com-mail-check-filled",
    comMailMinusFilled = "com-mail-minus-filled",
    comMailOpenFilled = "com-mail-open-filled",
    comMailOpenWarningFilled = "com-mail-open-warning-filled",
    comMailPlusFilled = "com-mail-plus-filled",
    comMailReceiveFilled = "com-mail-receive-filled",
    comMailSyncFilled = "com-mail-sync-filled",
    comMailWarningFilled = "com-mail-warning-filled",
    comMegaphoneFilled = "com-megaphone-filled",
    comMicFilled = "com-mic-filled",
    comMicMuteFilled = "com-mic-mute-filled",
    comMicrophonePodcastFilled = "com-microphone-podcast-2-filled",
    comPaperplaneFilled = "com-paperplane-filled",
    comPhoneFilled = "com-phone-filled",
    comPhoneLandlineFilled = "com-phone-landline-filled",
    comPicturesFilled = "com-pictures-filled",
    comPostcardFilled = "com-postcard-filled",
    comSatelliteFilled = "com-satellite-filled",
    comVoicemailFilled = "com-voicemail-filled",
    comWarningFilled = "com-warning-filled",
    docAnalyticsUpFilled = "doc-analytics-up-filled",
    docArchiveDownloadFilled = "doc-archive-download-filled",
    docArchiveEmptyFilled = "doc-archive-empty-filled",
    docArchiveFilled = "doc-archive-filled",
    docArchiveFolderFilled = "doc-archive-folder-filled",
    docArchiveUploadFilled = "doc-archive-upload-filled",
    docArticleFilled = "doc-article-filled",
    docAttachmentFilled = "doc-attachment-filled",
    docBookAFilled = "doc-book-a-filled",
    docBookBFilled = "doc-book-b-filled",
    docBookCashFilled = "doc-book-cash-filled",
    docBookDownloadFilled = "doc-book-download-filled",
    docBookFilled = "doc-book-filled",
    docBookLibraryFilled = "doc-book-library-filled",
    docBookmarkFilled = "doc-bookmark-filled",
    docBookModulesFilled = "doc-book-modules-filled",
    docBookSettingsFilled = "doc-book-settings-filled",
    docBookTargetFilled = "doc-book-target-filled",
    docBookUploadFilled = "doc-book-upload-filled",
    docBoxPFilled = "doc-box-p-filled",
    docBriefcaseFilled = "doc-briefcase-filled",
    docCameraFilled = "doc-camera-filled",
    docCommonFileEditFilled = "doc-common-file-edit-filled",
    docCommonFileHomeFilled = "doc-common-file-home-filled",
    docCommonFileTextEditFilled = "doc-common-file-text-edit-filled",
    docComposeFilled = "doc-compose-filled",
    docCopyFilled = "doc-copy-filled",
    docDiaryFilled = "doc-diary-filled",
    docDownloadFilled = "doc-download-filled",
    docFileBlankFilled = "doc-file-blank-filled",
    docFileBookmarkFilled = "doc-file-bookmark-filled",
    docFileCrossFilled = "doc-file-cross-filled",
    docFileCheckFilled = "doc-file-check-filled",
    docFileLineFilled = "doc-file-line-filled",
    docFileMinusFilled = "doc-file-minus-filled",
    docFileNextFilled = "doc-file-next-filled",
    docFilePlusFilled = "doc-file-plus-filled",
    docFilePrevFilled = "doc-file-prev-filled",
    docFilePrintFilled = "doc-file-print-filled",
    docFileRefreshFilled = "doc-file-refresh-filled",
    docFileSaveFilled = "doc-file-save-filled",
    docFileXlsFilled = "doc-file-xls-filled",
    docFolderCrossFilled = "doc-folder-cross-filled",
    docFolderFilled = "doc-folder-filled",
    docFolderHomeFilled = "doc-folder-home-filled",
    docFolderCheckFilled = "doc-folder-check-filled",
    docFolderMinusFilled = "doc-folder-minus-filled",
    docFolderPlusFilled = "doc-folder-plus-filled",
    docFolderSyncFilled = "doc-folder-sync-filled",
    docGlassesFilled = "doc-glasses-filled",
    docIdCardVerticalFilled = "doc-id-card-vertical-filled",
    docImageAFilled = "doc-image-a-filled",
    docImageFilled = "doc-image-filled",
    docInvoiceFilled = "doc-invoice-filled",
    docListFilled = "doc-list-filled",
    docListNumbersFilled = "doc-list-numbers-filled",
    docMailboxInFilled = "doc-mailbox-in-filled",
    docMinusFilled = "doc-minus-filled",
    docNewspaperFilled = "doc-newspaper-filled",
    docNotesFlipFilled = "doc-notes-flip-filled",
    docNotesGiveFilled = "doc-notes-give-filled",
    docNotesHomeFilled = "doc-notes-home-filled",
    docNotesPaperTextFilled = "doc-notes-paper-text-filled",
    docNotesUploadFilled = "doc-notes-upload-filled",
    docOfficeFilePdfFilled = "doc-office-file-pdf-filled",
    docOfficeFolderFilled = "doc-office-folder-filled",
    docOfficeStampDocumentFilled = "doc-office-stamp-document-filled",
    docPaperLineFilled = "doc-paper-line-filled",
    docPapersFilled = "doc-papers-filled",
    docPaperStackFilled = "doc-paper-stack-filled",
    docPieFilled = "doc-pie-filled",
    docPinFilled = "doc-pin-filled",
    docPlusFilled = "doc-plus-filled",
    docPrinterFilled = "doc-printer-filled",
    docProfileFilled = "doc-profile-filled",
    docStackFilled = "doc-stack-filled",
    docTaskChecklistFilled = "doc-task-checklist-filled",
    docTaskListQuestionFilled = "doc-task-list-question-filled",
    docTodoListFilled = "doc-todo-list-filled",
    docTodoListSquareFilled = "doc-todo-list-square-filled",
    docTodoListUserFilled = "doc-todo-list-user-filled",
    docUploadFilled = "doc-upload-filled",
    docWboardArrowTopFilled = "doc-wboard-arrow-top-filled",
    docWboardGearFilled = "doc-wboard-gear-filled",
    docWboardCheckFilled = "doc-wboard-check-filled",
    docWboardLineFilled = "doc-wboard-line-filled",
    docWboardSearchFilled = "doc-wboard-search-filled",
    editorialAlignCenterFilled = "editorial-align-center-filled",
    editorialAlignLeftFilled = "editorial-align-left-filled",
    editorialAlignRightFilled = "editorial-align-right-filled",
    editorialBookmarkFilled = "editorial-bookmar-filled",
    editorialBrushFilled = "editorial-brush-filled",
    editorialColorPaletteFilled = "editorial-color-palette-filled",
    editorialCombineIntersectFilled = "editorial-combine-intersect-filled",
    editorialFontSizeFilled = "editorial-font-size-filled",
    editorialHashFilled = "editorial-hash-filled",
    editorialIndentLeftFilled = "editorial-indent-left-filled",
    editorialIndentRightFilled = "editorial-indent-right-filled",
    editorialItalicOffFilled = "editorial-italic-off-filled",
    editorialParagraphFilled = "editorial-paragraph-filled",
    editorialParagraphFirstLetterFilled = "editorial-paragraph-first-letter-filled",
    editorialPencilFilled = "editorial-pencil-filled",
    editorialPencilSmallFilled = "editorial-pencil-small-filled",
    editorialPenFilled = "editorial-pen-filled",
    editorialRedoFilled = "editorial-redo-filled",
    editorialSortAscFilled = "editorial-sort-asc-filled",
    editorialSortCancelFilled = "editorial-sort-cancel-filled",
    editorialSortDescFilled = "editorial-sort-desc-filled",
    editorialTextBoldFilled = "editorial-text-bold-filled",
    editorialTextFormatFilled = "editorial-text-format-filled",
    editorialTextItalicFilled = "editorial-text-italic-filled",
    editorialTextStrikeFilled = "editorial-text-strike-through-filled",
    editorialTextStyleFilled = "editorial-text-style-filled",
    editorialTextUnderlineFilled = "editorial-text-underline-filled",
    editorialTrashFilled = "editorial-trash-filled",
    editorialTypingMachineFilled = "editorial-typing-machine-filled",
    editorialUndoFilled = "editorial-undo-filled",
    envAtomicBombFilled = "env-atomic-bomb-filled",
    envEarthFilled = "env-earth-filled",
    envFlowerFilled = "env-flower-filled",
    envLeafFilled = "env-leaf-filled",
    envMountainsFilled = "env-mountains-filled",
    envTreeAFilled = "env-tree-a-filled",
    envTreeFilled = "env-tree-filled",
    locationCompassFilled = "location-compass-filled",
    locationDirectionFilled = "location-direction-filled",
    locationDirectionSignFilled = "location-direction-sign-filled",
    locationMapCrossFilled = "location-map-cross-filled",
    locationMapFilled = "location-map-filled",
    locationPinAFilled = "location-pin-a-filled",
    locationPinBFilled = "location-pin-b-filled",
    locationPinFilled = "location-pin-filled",
    locationPinCheckFilled = "location-pin-check-filled",
    locationPinMapFilled = "location-pin-map-filled",
    locationPinMinusFilled = "location-pin-minus-filled",
    locationPinPlusFilled = "location-pin-plus-filled",
    locationPinsFilled = "location-pins-filled",
    locationStreetSignAFilled = "location-street-sign-a-filled",
    locationStreetSignFilled = "location-street-sign-filled",
    logoAppleFilled = "logo-apple-filled",
    logoLinuxFilled = "logo-linux-filled",
    logoWindowsFilled = "logo-windows-filled",
    miscBulletDiamondFilled = "misc-bullet-diamond-filled",
    miscCrownFilled = "misc-crown-filled",
    miscCubeFilled = "misc-cube-filled",
    miscCursorHandOpenFilled = "misc-cursor-hand-open-filled",
    miscFemaleSignFilled = "misc-female-sign-filled",
    miscGestureDoubleTapFilled = "misc-gesture-double-tap-filled",
    miscGestureFilled = "misc-gesture-filled",
    miscGestureSwipeLeftFilled = "misc-gesture-swipe-left-filled",
    miscGestureSwipeRightFilled = "misc-gesture-swipe-right-filled",
    miscGestureTapFilled = "misc-gesture-tap-filled",
    miscGlobeFilled = "misc-globe-filled",
    miscGridPerspectiveFilled = "misc-grid-perspective-filled",
    miscMaleSignFilled = "misc-male-sign-filled",
    miscPuzzleFilled = "misc-puzzle-filled",
    miscReceptionHotelBellFilled = "misc-reception-hotel-bell-filled",
    miscSmileAngryFilled = "misc-smile-angry-filled",
    miscSmileHappyFilled = "misc-smile-happy-filled",
    miscSmileLaughtFilled = "misc-smile-laught-filled",
    miscSmileMehFilled = "misc-smile-meh-filled",
    miscSmileSadFilled = "misc-smile-sad-filled",
    miscWifiFilled = "misc-wifi-filled",
    musicAlbumFilled = "music-album-filled",
    musicCdFilled = "music-cd-filled",
    musicEjectFilled = "music-eject-filled",
    musicEqualiserFilled = "music-equaliser-filled",
    musicListFilled = "music-list-filled",
    musicMicFilled = "music-mic-filled",
    musicNextAFilled = "music-next-a-filled",
    musicNextFilled = "music-next-filled",
    musicNoteAFilled = "music-note-a-filled",
    musicNoteFilled = "music-note-filled",
    musicPauseFilled = "music-pause-filled",
    musicPlayFilled = "music-play-filled",
    musicPlaylistFilled = "music-playlist-filled",
    musicPreviousAFilled = "music-previous-a-filled",
    musicPreviousFilled = "music-previous-filled",
    musicRadioFilled = "music-radio-filled",
    musicRepeatFilled = "music-repeat-filled",
    musicRepeatOneFilled = "music-repeat-one-filled",
    musicShuffleFilled = "music-shuffle-filled",
    musicSpeakerFilled = "music-speaker-filled",
    musicStopFilled = "music-stop-filled",
    musicVolumeHighFilled = "music-volume-high-filled",
    musicVolumeLowFilled = "music-volume-low-filled",
    musicVolumeMediumFilled = "music-volume-medium-filled",
    musicVolumeMuteFilled = "music-volume-mute-filled",
    musicHeadphonesAFilled = "music-headphones-a-filled",
    musicHeadphonesFilled = "music-headphones-filled",
    settingsAirplaneFilled = "settings-airplane-filled",
    settingsAutoFlashFilled = "settings-auto-flash-filled",
    settingsColorModeFilled = "settings-color-mode-filled",
    settingsComonentFilled = "settings-comonent-filled",
    settingsEqualizerFilled = "settings-equalizer-filled",
    settingsGearAFilled = "settings-gear-a-filled",
    settingsGearFilled = "settings-gear-filled",
    settingsHotspotFilled = "settings-hotspot-filled",
    settingsMachineTrackFilled = "settings-machine-track-filled",
    settingsWrenchFilled = "settings-wrench-filled",
    shopAccountingBillStackFilled = "shop-accounting-bill-stack-filled",
    shopBagFilled = "shop-bag-filled",
    shopBarcodeFilled = "shop-barcode-filled",
    shopBasketFilled = "shop-basket-filled",
    shopBillFilled = "shop-bill-filled",
    shopBoxEmptyFilled = "shop-box-empty-filled",
    shopBoxFilled = "shop-box-filled",
    shopBoxMinusFilled = "shop-box-minus-filled",
    shopBoxPlusFilled = "shop-box-plus-filled",
    shopCartDownloadFilled = "shop-cart-download-filled",
    shopCartEmptyFilled = "shop-cart-empty-filled",
    shopCartFullFilled = "shop-cart-full-filled",
    shopCashDolarFilled = "shop-cash-dolar-filled",
    shopCashFilled = "shop-cash-filled",
    shopCoinsFilled = "shop-coins-filled",
    shopCreditcardFilled = "shop-creditcard-filled",
    shopDiamondFilled = "shop-diamond-filled",
    shopDiscountCircleFilled = "shop-discount-circle-filled",
    shopDiscountCouponFilled = "shop-discount-coupon-filled",
    shopDolarFilled = "shop-dolar-filled",
    shopEuroFilled = "shop-euro-filled",
    shopMarketFilled = "shop-market-filled",
    shopMastercardFilled = "shop-mastercard-filled",
    shopPerformanceMoneyDecreaseFilled = "shop-performance-money-decrease-filled",
    shopPoundFilled = "shop-pound-filled",
    shopPresentFilled = "shop-present-filled",
    shopSafeBoxFilled = "shop-safe-box-filled",
    shopSavingPiggyBankFilled = "shop-saving-piggy-bank-filled",
    shopShipmentPackagesFilled = "shop-shipment-packages-filled",
    shopSuitcaseFilled = "shop-suitcase-filled",
    shopTagDatabaseFilled = "shop-tag-database-filled",
    shopTagFilled = "shop-tag-filled",
    shopTagCheckFilled = "shop-tag-check-filled",
    shopTagInfoFilled = "shop-tag-info-filled",
    shopTagLockFilled = "shop-tag-lock-filled",
    shopTagMinusFilled = "shop-tag-minus-filled",
    shopTagPlusFilled = "shop-tag-plus-filled",
    shopTagRefreshFilled = "shop-tag-refresh-filled",
    shopTagSearchFilled = "shop-tag-search-filled",
    shopTieFilled = "shop-tie-filled",
    shopTrackingFilled = "shop-tracking-filled",
    shopWalletFilled = "shop-wallet-filled",
    sportBadgeBFilled = "sport-badge-b-filled",
    sportBadgeCFilled = "sport-badge-c-filled",
    sportBadgeFilled = "sport-badge-filled",
    sportBadgeHFilled = "sport-badge-h-filled",
    sportDumbellFilled = "sport-dumbell-filled",
    sportFlagFilled = "sport-flag-filled",
    sportGaugeFilled = "sport-gauge-filled",
    sportHeartPulseFilled = "sport-heart-pulse-filled",
    sportMedicFilled = "sport-medic-filled",
    sportMedicineLabFilled = "sport-medicine-lab-filled",
    sportPuzzleFilled = "sport-puzzle-filled",
    sportTrophyFilled = "sport-trophy-filled",
    sportTvFilled = "sport-tv-filled",
    timeAlarmFilled = "time-alarm-filled",
    timeCalendarCashFilled = "time-calendar-cash-filled",
    timeCalendarClockFilled = "time-calendar-clock-filled",
    timeCalendarDotsFilled = "time-calendar-dots-filled",
    timeCalendarFilled = "time-calendar-filled",
    timeCalendarSmallFilled = "time-calendar-small-filled",
    timeCalendarWeekFilled = "time-calendar-week-filled",
    timeClockCircleFilled = "time-clock-circle-filled",
    timeClockFFilled = "time-clock-f-filled",
    timeHourglassFilled = "time-hourglass-filled",
    timeSpeedMeterFilled = "time-speed-meter-filled",
    timeStopwatchFilled = "time-stopwatch-filled",
    timeTimerFilled = "time-timer-filled",
    timeWatchFilled = "time-watch-filled",
    toolAndroidTypeFilled = "tool-android-type-filled",
    toolAreaTypeFilled = "tool-area-type-filled",
    toolBinocularsFilled = "tool-binoculars-filled",
    toolCalcFilled = "tool-calc-filled",
    toolCameraFilled = "tool-camera-filled",
    toolCompassFilled = "tool-compass-filled",
    toolConsoleAFilled = "tool-console-a-filled",
    toolConsoleFilled = "tool-console-filled",
    toolDisplayFilled = "tool-display-filled",
    toolDisplayUserFilled = "tool-display-user-filled",
    toolFireExtinguisherFilled = "tool-fire-extinguisher-filled",
    toolFlashlightFilled = "tool-flashlight-filled",
    toolFloppyDiskFilled = "tool-floppy-disk-filled",
    toolFloppyDisksFilled = "tool-floppy-disks-filled",
    toolFloppyEditFilled = "tool-floppy-edit-filled",
    toolFocuFilled = "tool-focus-filled",
    toolGearsTypeFilled = "tool-gears-type-filled",
    toolGridFilled = "tool-grid-filled",
    toolHammerAFilled = "tool-hammer-a-filled",
    toolHammerAngleFilled = "tool-hammer-angle-filled",
    toolHammerFilled = "tool-hammer-filled",
    toolHammerPlusFilled = "tool-hammer-plus-filled",
    toolHardwareTypeFilled = "tool-hardware-type-filled",
    toolIntTypeFilled = "tool-int-type-filled",
    toolLaptopFilled = "tool-laptop-filled",
    toolMagicWandFilled = "tool-magic-wand-filled",
    toolMagnetFilled = "tool-magnet-filled",
    toolModuleThreeFilled = "tool-module-three-filled",
    toolMouseFilled = "tool-mouse-filled",
    toolPhoneFilled = "tool-phone-filled",
    toolPhoneLandscapeFilled = "tool-phone-landscape-filled",
    toolPlugFilled = "tool-plug-filled",
    toolProjectorFilled = "tool-projector-filled",
    toolPropertyTypeFilled = "tool-property-type-filled",
    toolProtectionTypeFilled = "tool-protection-type-filled",
    toolRazorFilled = "tool-razor-filled",
    toolRouterSignalFilled = "tool-router-signal-filled",
    toolRulerBFilled = "tool-ruler-b-filled",
    toolRulerCornerFilled = "tool-ruler-corner-filled",
    toolRulerFilled = "tool-ruler-filled",
    toolSateliteTypeFilled = "tool-satelite-type-filled",
    toolsBoxFilled = "tools-box-filled",
    toolScissorsFilled = "tool-scissors-filled",
    toolSmartphonePayFilled = "tool-smartphone-pay-filled",
    toolTextTypeFilled = "tool-text-type-filled",
    toolUmbrellaFilled = "tool-umbrella-filled",
    transportBicycleFilled = "transport-bicycle-filled",
    transportBusAFilled = "transport-bus-a-filled",
    transportBusFilled = "transport-bus-filled",
    transportBusTicketFilled = "transport-bus-ticket-filled",
    transportCarAFilled = "transport-car-a-filled",
    transportCarFilled = "transport-car-filled",
    transportShipAFilled = "transport-ship-a-filled",
    transportShipFilled = "transport-ship-filled",
    transportSignStopFilled = "transport-sign-stop-filled",
    transportTrainFilled = "transport-train-filled",
    transportTruckAFilled = "transport-truck-a-filled",
    transportTruckFilled = "transport-truck-filled",
    uiAddConnectionPointFilled = "ui-add-connection-point-filled",
    uiAlignBottomFilled = "ui-align-bottom-filled",
    uiAlignLeftFilled = "ui-align-left-filled",
    uiAlignRightFilled = "ui-align-right-filled",
    uiAlignTopFilled = "ui-align-top-filled",
    uiArrowBottomAFilled = "ui-arrow-bottom-a-filled",
    uiArrowBottomFilled = "ui-arrow-bottom-filled",
    uiArrowBottomLeftFilled = "ui-arrow-bottom-left-filled",
    uiArrowBottomRightFilled = "ui-arrow-bottom-right-filled",
    uiArrowBottomSmallFilled = "ui-arrow-bottom-small-filled",
    uiArrowLeftAFilled = "ui-arrow-left-a-filled",
    uiArrowLeftFilled = "ui-arrow-left-filled",
    uiArrowLeftSmallFilled = "ui-arrow-left-small-filled",
    uiArrowRightAFilled = "ui-arrow-right-a-filled",
    uiArrowRightFilled = "ui-arrow-right-filled",
    uiArrowRightSmallFilled = "ui-arrow-right-small-filled",
    uiArrowTopAFilled = "ui-arrow-top-a-filled",
    uiArrowTopFilled = "ui-arrow-top-filled",
    uiArrowTopLeftFilled = "ui-arrow-top-left-filled",
    uiArrowTopRightFilled = "ui-arrow-top-right-filled",
    uiArrowTopSmallFilled = "ui-arrow-top-small-filled",
    uiAttributeFilled = "ui-attribute-filled",
    uiAttributeInheritedFilled = "ui-attribute-inherited-filled",
    uiBackspaceFilled = "ui-backspace-filled",
    uiBlockFilled = "ui-block-filled",
    uiBoxHelpFilled = "ui-box-help-filled",
    uiBoxWarningFilled = "ui-box-warning-filled",
    uiBulletViewFilled = "ui-bullet-view-filled",
    uiCardFilled = "ui-card-filled",
    uiCardViewFilled = "ui-card-view-filled",
    uiCircleArrowBottomFilled = "ui-circle-arrow-bottom-filled",
    uiCircleArrowLeftFilled = "ui-circle-arrow-left-filled",
    uiCircleArrowRightFilled = "ui-circle-arrow-right-filled",
    uiCircleArrowTopFilled = "ui-circle-arrow-top-filled",
    uiCircleCrossFilled = "ui-circle-cross-filled",
    uiCircleFilled = "ui-circle-filled",
    uiCircleHelpFilled = "ui-circle-help-filled",
    uiCircleCheckAFilled = "ui-circle-check-a-filled",
    uiCircleCheckFilled = "ui-circle-check-filled",
    uiCircleChevronBottomFilled = "ui-circle-chevron-bottom-filled",
    uiCircleChevronLeftFilled = "ui-circle-chevron-left-filled",
    uiCircleChevronRightFilled = "ui-circle-chevron-right-filled",
    uiCircleChevronTopFilled = "ui-circle-chevron-top-filled",
    uiCircleInfoFilled = "ui-circle-info-filled",
    uiCircleMinusFilled = "ui-circle-minus-filled",
    uiCirclePlusFilled = "ui-circle-plus-filled",
    uiCircleWarningFilled = "ui-circle-warning-filled",
    uiCloseParallelConnectionFilled = "ui-close-parallel-connection-filled",
    uiCloudDownloadFilled = "ui-cloud-download-filled",
    uiCloudUploadFilled = "ui-cloud-upload-filled",
    uiCmdFilled = "ui-cmd-filled",
    uiComboboxFilled = "ui-combobox-filled",
    uiConditionFilled = "ui-condition-filled",
    uiConeFilled = "ui-cone-filled",
    uiConnectionFilled = "ui-connection-filled",
    uiConnectionInheritedFilled = "ui-connection-inherited-filled",
    uiConnectionOpenFilled = "ui-connection-open-filled",
    uiConnectionOpenInheritedFilled = "ui-connection-open-inherited-filled",
    uiCreateConnectionFilled = "ui-create-connection-filled",
    uiCropFilled = "ui-crop-filled",
    uiCrossFilled = "ui-cross-filled",
    uiCrossSmallFilled = "ui-cross-small-filled",
    uiDotFilled = "ui-dot-filled",
    uiDotLargeFilled = "ui-dot-large-filled",
    uiDragHandleFilled = "ui-drag-handle-filled",
    uiEnlargeFilled = "ui-enlarge-filled",
    uiExpandFilled = "ui-expand-filled",
    uiExportFilled = "ui-export-filled",
    uiEyeCrossFilled = "ui-eye-cross-filled",
    uiEyeFilled = "ui-eye-filled",
    uiFilterFilled = "ui-filter-filled",
    uiForwardFilled = "ui-forward-filled",
    uiFrameFilled = "ui-frame-filled",
    uiFullscreenAFilled = "ui-fullscreen-a-filled",
    uiFullscreenFilled = "ui-fullscreen-filled",
    uiGridViewFilled = "ui-grid-view-filled",
    uiHamburgerFilled = "ui-hamburger-filled",
    uiHeartFilled = "ui-heart-filled",
    uiHelpFilled = "ui-help-filled",
    uiHierarchyFilled = "ui-hierarchy-filled",
    uiHierarchyTreeFilled = "ui-hierarchy-tree-filled",
    uiHomeAFilled = "ui-home-a-filled",
    uiHomeFilled = "ui-home-filled",
    uiHouseFilled = "ui-house-filled",
    uiCheckboxFilled = "ui-checkbox-filled",
    uiCheckFilled = "ui-check-filled",
    uiCheckSmallCircleFilled = "ui-check-small-circle-filled",
    uiCheckSmallFilled = "ui-check-small-filled",
    uiChevronBottomFilled = "ui-chevron-bottom-filled",
    uiChevronBottomSmallFilled = "ui-chevron-bottom-small-filled",
    uiChevronLeftFilled = "ui-chevron-left-filled",
    uiChevronLeftSmallFilled = "ui-chevron-left-small-filled",
    uiChevronRightFilled = "ui-chevron-right-filled",
    uiChevronRightSmallFilled = "ui-chevron-right-small-filled",
    uiChevronRightTrippleFilled = "ui-chevron-right-tripple-filled",
    uiChevronTopFilled = "ui-chevron-top-filled",
    uiChevronTopSmallFilled = "ui-chevron-top-small-filled",
    uiImportFilled = "ui-import-filled",
    uiInLinkFilled = "ui-in-link-filled",
    uiKeyboardFilled = "ui-keyboard-filled",
    uiLayoutHalfFilled = "ui-layout-half-filled",
    uiLayoutHalfHorizontalFilled = "ui-layout-half-horizontal-filled",
    uiLayoutSidebarLFilled = "ui-layout-sidebar-l-filled",
    uiLayoutSidebarLHalfFilled = "ui-layout-sidebar-l-half-filled",
    uiLayoutTableViewFilled = "ui-layout-table-view-filled",
    uiLayoutThirdVerticalFilled = "ui-layout-third-vertical-filled",
    uiLayoutWireframeFilled = "ui-layout-wireframe-filled",
    uiListForwardFilled = "ui-list-forward-filled",
    uiListShareFilled = "ui-list-share-filled",
    uiListUserFilled = "ui-list-user-filled",
    uiListViewFilled = "ui-list-view-filled",
    uiLoginFilled = "ui-login-filled",
    uiLogoutFilled = "ui-logout-filled",
    uiMethodFilled = "ui-method-filled",
    uiMethodInheritedFilled = "ui-method-inherited-filled",
    uiMinusFilled = "ui-minus-filled",
    uiMinusSmallFilled = "ui-minus-small-filled",
    uiMoreFilled = "ui-more-filled",
    uiMoreHorizontalSmallFilled = "ui-more-horizontal-small-filled",
    uiMoreSmallCircleFilled = "ui-more-small-circle-filled",
    uiMoreSmallFilled = "ui-more-small-filled",
    uiMoreVerticalFilled = "ui-more-vertical-filled",
    uiMoreVerticalSmallFilled = "ui-more-vertical-small-filled",
    uiMoveFilled = "ui-move-filled",
    uiNextAFilled = "ui-next-a-filled",
    uiNextFilled = "ui-next-filled",
    uiNumberFilled = "ui-number-filled",
    uiOutLinkFilled = "ui-out-link-filled",
    uiPixelFilled = "ui-pixel-filled",
    uiPlusFilled = "ui-plus-filled",
    uiPlusSmallFilled = "ui-plus-small-filled",
    uiPopupFilled = "ui-popup-filled",
    uiPowerFilled = "ui-power-filled",
    uiPreviousAFilled = "ui-previous-a-filled",
    uiPreviousFilled = "ui-previous-filled",
    uiPropertyAndFilled = "ui-property-and-filled",
    uiRadiobuttonFilled = "ui-radiobutton-filled",
    uiRefreshFilled = "ui-refresh-filled",
    uiRemoveConnectionPointFilled = "ui-remove-connection-point-filled",
    uiRepeatingFilled = "ui-repeating-filled",
    uiReplyFilled = "ui-reply-filled",
    uiResizeBottomLeftFilled = "ui-resize-bottom-left-filled",
    uiResizeBottomRightFilled = "ui-resize-bottom-right-filled",
    uiResizeDiagonalFilled = "ui-resize-diagonal-filled",
    uiResizeHorizontalFilled = "ui-resize-horizontal-filled",
    uiResizeTopLeftFilled = "ui-resize-top-left-filled",
    uiResizeTopRightFilled = "ui-resize-top-right-filled",
    uiResizeVerticalFilled = "ui-resize-vertical-filled",
    uiScrollHorizontalFilled = "ui-scroll-horizontal-filled",
    uiScrollVerticalFilled = "ui-scroll-vertical-filled",
    uiSearchCrossFilled = "ui-search-cross-filled",
    uiSearchFilled = "ui-search-filled",
    uiSearchCheckFilled = "ui-search-check-filled",
    uiSearchMinusFilled = "ui-search-minus-filled",
    uiSearchPlusFilled = "ui-search-plus-filled",
    uiShrinkFilled = "ui-shrink-filled",
    uiSplitHorizontalFilled = "ui-split-horizontal-filled",
    uiSplitVerticalFilled = "ui-split-vertical-filled",
    uiSqareDashedFilled = "ui-sqare-dashed-filled",
    uiStarFilled = "ui-star-filled",
    uiSyncFilled = "ui-sync-filled",
    uiTargetFilled = "ui-target-filled",
    uiTreeLoadFilled = "ui-tree-load-filled",
    uiTreeSaveFilled = "ui-tree-save-filled",
    uiTriangleBottomFilled = "ui-triangle-bottom-filled",
    uiTriangleLeftFilled = "ui-triangle-left-filled",
    uiTriangleRightFilled = "ui-triangle-right-filled",
    uiTriangleTopFilled = "ui-triangle-top-filled",
    uiUndoAFilled = "ui-undo-a-filled",
    uiUndoBFilled = "ui-undo-b-filled",
    uiUndoFilled = "ui-undo-filled",
    uiWindowFilled = "ui-window-filled",
    uiZoomInPageFilled = "ui-zoom-in-page-filled",
    userBusinessDealCashExchangeFilled = "user-business-deal-cash-exchange-filled",
    userCircleFilled = "user-circle-filled",
    userContactBookAFilled = "user-contact-book-a-filled",
    userContactBookFilled = "user-contact-book-filled",
    userCrossFilled = "user-cross-filled",
    userFemaleCrossFilled = "user-female-cross-filled",
    userFemaleFilled = "user-female-filled",
    userFemaleCheckFilled = "user-female-check-filled",
    userFemaleListFilled = "user-female-list-filled",
    userFemaleMinusFilled = "user-female-minus-filled",
    userFemalePlusFilled = "user-female-plus-filled",
    userFemaleSignFilled = "user-female-sign-filled",
    userFilled = "user-filled",
    userForwardFilled = "user-forward-filled",
    userGearFilled = "user-gear-filled",
    userGroupAFilled = "user-group-a-filled",
    userGroupFemaleFilled = "user-group-female-filled",
    userGroupFilled = "user-group-filled",
    userHeadsetFilled = "user-headset-filled",
    userCheckAFilled = "user-check-a-filled",
    userCheckBFilled = "user-check-b-filled",
    userCheckFilled = "user-check-filled",
    userKeyFilled = "user-key-filled",
    userListFilled = "user-list-filled",
    userLockFilled = "user-lock-filled",
    userLockUnlockedFilled = "user-lock-unlocked-filled",
    userLockUnlockedFilledB = "user-lock-unlocked-b-filled",
    userMaleCrossFilled = "user-male-cross-filled",
    userMaleFilled = "user-male-filled",
    userMaleCheckFilled = "user-male-check-filled",
    userMaleListFilled = "user-male-list-filled",
    userMaleMinusFilled = "user-male-minus-filled",
    userMalePlusFilled = "user-male-plus-filled",
    userMaleSignFilled = "user-male-sign-filled",
    userMessagesPeopleUserWarningFilled = "user-messages-people-user-warning-filled",
    userMinusFilled = "user-minus-filled",
    userMultipleUsersFilled = "user-multiple-users-filled",
    userPlusFilled = "user-plus-filled",
    userShareFilled = "user-share-filled",
    userSingleNeutralActionsBlockFilled = "user-single-neutral-actions-block-filled",
    userSingleNeutralActionsEditFilled = "user-single-neutral-actions-edit-filled",
    userSingleNeutralHomeFilled = "user-single-neutral-home-filled",
    userToiletSignFilled = "user-toilet-sign-filled",
    userWalkingFilled = "user-walking-filled",
    videoPlayerFilled = "video-player-filled",
    weatherCloudFilled = "weather-cloud-filled",
    weatherCloudFlashFilled = "weather-cloud-flash-filled",
    weatherCloudRainFilled = "weather-cloud-rain-filled",
    weatherCloudSnowFilled = "weather-cloud-snow-filled",
    weatherFireFilled = "weather-fire-filled",
    weatherFlashFilled = "weather-flash-filled",
    weatherMoonAFilled = "weather-moon-a-filled",
    weatherMoonFilled = "weather-moon-filled",
    weatherSnowflakeFilled = "weather-snowflake-filled",
    weatherSunCloudSnowFilled = "weather-sun-cloud-snow-filled",
    weatherSunFilled = "weather-sun-filled",
    weatherSunriseFilled = "weather-sunrise-filled",
    weatherThermometerFilled = " weather-thermometer-filled",
    weatherWaterFilled = "weather-water-filled",
    weatherWindsockFilled = "weather-windsock-filled",
    webAnalyticsNetFilled = "web-analytics-net-filled",
    webAtSignFilled = "web-at-sign-filled",
    webBarsHomeFilled = "web-bars-home-filled",
    webBrokenLinkFilled = "web-broken-link-filled",
    webBrowserFilled = "web-browser-filled",
    webBrowserGridFilled = "web-browser-grid-filled",
    webBrowserWindowFilled = "web-browser-window-filled",
    webBugFilled = "web-bug-filled",
    webCodeFilled = "web-code-filled",
    webCollapseDownFilled = "web-collapse-down-filled",
    webCollapseLeftFilled = "web-collapse-left-filled",
    webCollapseRightFilled = "web-collapse-right-filled",
    webCollapseUpFilled = "web-collapse-up-filled",
    webConsoleFilled = "web-console-filled",
    webDataFileBarsFilled = "web-data-file-bars-filled",
    webDataFileBarsHomeFilled = "web-data-file-bars-home-filled",
    webFlagCFilled = "web-flag-c-filled",
    webFlagFilled = "web-flag-filled",
    webGlobeFilled = "web-globe-filled",
    webGridUploadFilled = "web-grid-upload-filled",
    webChartFilled = "web-chart-filled",
    webIncreaseMailFilled = "web-increase-mail-filled",
    webLinkBFilled = "web-link-b-filled",
    webLinkBCheckFilled = "web-link-b-check-filled",
    webLinkFilled = "web-link-filled",
    webRssFilled = "web-rss-filled",
    webRssSettingsFilled = "web-rss-settings-filled",
    webServerFilled = "web-server-filled",
    webShareFilled = "web-share-filled",
    webStatisticFilled = "web-statistic-filled",
    webTabletIncreaseFilled = "web-tablet-increase-filled",
    webTabsCrossFilled = "web-tabs-cross-filled",
    webTabsFilled = "web-tabs-filled",
    webTabsCheckFilled = "web-tabs-check-filled",
    webTabsMinusFilled = "web-tabs-minus-filled",
    webTabsPlusFilled = "web-tabs-plus-filled",
    webWarningFilled = "web-warning-filled",
    webWebcamFilled = "web-webcam-filled",
}
